{
  "version": 1,
  "asset_id": "4d2742c2-a2be-45d9-b56d-f3766fbca386",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/4d2742c2-a2be-45d9-b56d-f3766fbca386/rv_appliances.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/4d2742c2-a2be-45d9-b56d-f3766fbca386/rv_appliances.webp",
  "original_filename": "rv_appliances.webp",
  "size": 39834,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:18Z"
}
